import React from 'react';
import styled from 'styled-components';
import {
  mq,
  Subtitle,
  BodyLink,
  Breadcrumbs,
  NextIcon,
  BodyText
} from '@kvdbil/components';
import Link from '~/App/shared/components/Link';
import { useTranslation } from '~/Locale';
import Section from '~/App/shared/components/Layout/Section';

const BreadcrumbsWrapper = styled.div`
  margin-bottom: 1rem;
`;

const AllFamilyWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  column-gap: 3rem;

  ${mq('tablet')} {
    flex-direction: row;
  }
`;

const Title = styled(Subtitle)`
  margin-bottom: 0.75rem;
  flex-grow: 1;
  a {
    color: ${({ theme }) => theme.colors.text.dark};
  }
`;

const List = styled.ul`
  flex-grow: 4;
  column-count: 2;

  ${mq('mobileL')} {
    column-count: 3;
  }

  ${mq('tablet')} {
    column-count: 4;
  }
`;

const Item = styled(BodyLink)`
  margin-bottom: 1rem;
`;

const StyledLink = styled(Link)`
  && {
    color: ${({ theme }) => theme.colors.text.dark};
  }
`;

const Separator = styled(NextIcon)`
  && {
    color: ${({ theme }) => theme.colors.primary.main};
    width: 1.5rem;
    height: 1.5rem;
  }
`;

interface Props {
  brandName: string;
  brandSlug: string;
  familyName?: string;
  familySlug?: string;
  allFamily?: { name?: string | null; slug?: string | null }[];
}

const AllFamilyNavigationSection = ({
  brandName,
  brandSlug,
  familyName,
  familySlug,
  allFamily
}: Props) => {
  const { t } = useTranslation();
  const isFamilyPage = Boolean(familyName && familySlug);

  const breadcrumbsLinks = [
    {
      component: (
        <StyledLink to={'/ROUTES.FILTER_CAR'}>{t('Vehicles')}</StyledLink>
      )
    },
    {
      component: isFamilyPage ? (
        <StyledLink to={`/ROUTES.FILTER_CAR/${brandSlug}`}>
          {brandName}
        </StyledLink>
      ) : (
        <BodyText as="span">{brandName} </BodyText>
      )
    }
  ];
  isFamilyPage &&
    breadcrumbsLinks.push({
      component: <BodyText as="span">{familyName} </BodyText>
    });

  return (
    <Section
      maxWidth={64}
      spacingTop={1.5}
      spacingBottom={2}
      backgroundColor="light"
    >
      <BreadcrumbsWrapper>
        <Breadcrumbs links={breadcrumbsLinks} separator={<Separator />} />
      </BreadcrumbsWrapper>
      <AllFamilyWrapper>
        <Title as="h2">{`${brandName}${t('CAR_TREE(brand models)')}`}</Title>
        {allFamily && (
          <List>
            {allFamily?.map(({ name, slug }) => (
              <Item key={slug} as="li">
                <StyledLink
                  to={`/ROUTES.FILTER_CAR/${brandSlug}/${slug}`}
                >{`${brandName} ${name}`}</StyledLink>
              </Item>
            ))}
          </List>
        )}
      </AllFamilyWrapper>
    </Section>
  );
};

export default AllFamilyNavigationSection;
